import { useFlags, withLDProvider } from 'launchdarkly-react-client-sdk'
import { environment, featureFlagClientId } from 'Config'

const ANONYMOUS_KEY = 'zenqms-anonymous-user'

// The login page is pre-authentication, so there is never a member to target on:
// every evaluation uses the same anonymous multi-context the UI app boots with.
const anonymousContext = {
  kind: 'multi',
  user: { kind: 'user', key: ANONYMOUS_KEY, anonymous: true },
  member: { kind: 'member', key: ANONYMOUS_KEY, anonymous: true },
}

// Deliberately no `bootstrap: 'localStorage'` - a stale cached `true` is indistinguishable
// from a fresh one. Flags read before the SDK is ready are `undefined`, which every consumer
// must treat as "off" (see LoginLogo).
export const withFeatureFlags = featureFlagClientId
  ? withLDProvider({
    clientSideID: featureFlagClientId,
    context: anonymousContext,
    options: {
      streaming: true,
      application: {
        id: 'login',
        name: 'Login',
        version: environment,
      },
    },
  })
  // No client id configured (unknown/local-only env): render without LD, all flags off.
  : Component => Component

export const useFeatureFlags = () => useFlags()

export default {}
